<template><section><template>
<h3>浮出提示</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-tooltip content="tooltip on top" placement="top" trigger="hover">
    <n3-button>tooltip on top</n3-button>
  </n3-tooltip>
  <n3-tooltip content="tooltip on left" placement="left" trigger="hover">
    <n3-button>tooltip on left</n3-button>
  </n3-tooltip>
  <n3-tooltip content="tooltip on right" placement="right" trigger="hover">
    <n3-button>tooltip on right</n3-button>
  </n3-tooltip>
  <n3-tooltip content="tooltip on bottom" placement="bottom" trigger="hover">
    <n3-button>tooltip on bottom</n3-button>
  </n3-tooltip>
  <hr>
  <h4>Triger</h4>
  <p>
    <n3-tooltip trigger="click" effect="scale" content="Lorem ipsum dolor sit amet" placement="top">
      <n3-button>Click</n3-button>
    </n3-tooltip>
  </p>
  <n3-tooltip effect="scale" content="Lorem ipsum dolor sit amet" placement="bottom" trigger="focus">
    <n3-input placeholder="Focus"></n3-input>
  </n3-tooltip>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-tooltip</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"tooltip on top"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>&gt;</span>tooltip on top<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-tooltip</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tooltip</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"tooltip on left"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"left"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>tooltip on left<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-tooltip</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tooltip</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"tooltip on right"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"right"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>tooltip on right<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-tooltip</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tooltip</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"tooltip on bottom"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"hover"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>tooltip on bottom<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-tooltip</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">hr</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>Triger<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-tooltip</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"click"</span>
  <span class="hljs-attr">effect</span>=<span class="hljs-string">"scale"</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"Lorem ipsum dolor sit amet"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"top"</span> &gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> &gt;</span>Click<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-tooltip</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-tooltip</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"scale"</span> <span class="hljs-attr">content</span>=<span class="hljs-string">"Lorem ipsum dolor sit amet"</span> <span class="hljs-attr">placement</span>=<span class="hljs-string">"bottom"</span> <span class="hljs-attr">trigger</span>=<span class="hljs-string">"focus"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-input</span>  <span class="hljs-attr">placeholder</span>=<span class="hljs-string">"Focus"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-input</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-tooltip</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">title</span>: <span class="hljs-string">'Title'</span>,
      <span class="hljs-attr">text</span>: <span class="hljs-string">'Lorem ipsum dolor sit amet'</span>
    }
  }
}
</code></pre>
<h3>参数名</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>trigger</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">hover</code> <code v-pre="">focus</code> <code v-pre="">hover</code></td>
<td><code v-pre="">click</code></td>
<td>触发方式</td>
</tr>
<tr>
<td>effect</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">scale</code> <code v-pre="">fade</code></td>
<td><code v-pre="">scale</code></td>
<td></td>
</tr>
<tr>
<td>content</td>
<td><code v-pre="">String</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>placement</td>
<td><code v-pre="">String</code>, 如: <code v-pre="">top</code> <code v-pre="">left</code> <code v-pre="">right</code> <code v-pre="">bottom</code></td>
<td></td>
<td>定位方式</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      title: 'Title',
      text: 'Lorem ipsum dolor sit amet'
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TooltipDocs.md?537539a4